var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"main"},[_c('div',{staticClass:"rich-btn",class:{ 'rich-btn_disabled': _vm.isDisabled },on:{"click":_vm.handleLink}},[_vm._v(" "+_vm._s(_vm.btnText)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }